export enum PushNotificationTokenType {
  default = 'default',
  voip = 'VOIP',
}
